// import React, { useState } from "react";
// import {
//   Card,
//   CardContent,
//   Typography,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Avatar,
//   TablePagination,
//   TextField
// } from "@mui/material";

// // Sample stock data (Replace with dynamic data if needed)
// const stockData = [
//   { image: "https://via.placeholder.com/40", name: "Holger FIGO ROXO", category: "OTHER", stock: 100 },
//   { image: "https://via.placeholder.com/40", name: "Apples", category: "OTHER", stock: 228 },
//   { image: "https://via.placeholder.com/40", name: "Spinach", category: "OTHER", stock: 294 },
//   { image: "https://via.placeholder.com/40", name: "Carrot11", category: "OTHER", stock: 302 },
//   { image: "https://via.placeholder.com/40", name: "Orangeerer", category: "OTHER", stock: 473 },
//   { image: "https://via.placeholder.com/40", name: "Orangeerer", category: "OTHER", stock: 639 },
//   { image: "https://via.placeholder.com/40", name: "Adidas White", category: "OTHER", stock: 0 },
//   { image: "https://via.placeholder.com/40", name: "Doorman Coat", category: "OTHER", stock: 151 },
//   { image: "https://via.placeholder.com/40", name: "Grapes", category: "OTHER", stock: 212 },
//   { image: "https://via.placeholder.com/40", name: "Mangoes", category: "OTHER", stock: 178 },
// ];

// // Component
// const StockLevelsTable: React.FC = () => {
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);
//   const [searchTerm, setSearchTerm] = useState("");

//   // Filtered data based on search term
//   const filteredData = stockData.filter((item) =>
//     item.name.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   // Handle Pagination
//   const handleChangePage = (_event: unknown, newPage: number) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   return (
//     <Card sx={{ borderRadius: 1, padding: 1 }}>
//       <CardContent>
//         <Typography variant="h6" sx={{ fontWeight: "bold", textAlign: "left", marginBottom: 2 }}>
//           Stock Levels
//         </Typography>

//         {/* Search Bar */}
//         <TextField
//           label="Search by Name"
//           variant="outlined"
//           fullWidth
//           size="small"
//           sx={{ marginBottom: 2 }}
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />

//         {/* Table */}
//         <TableContainer>
//           <Table>
//             <TableHead>
//               <TableRow>
//                 <TableCell><strong>Image</strong></TableCell>
//                 <TableCell><strong>Name</strong></TableCell>
//                 <TableCell><strong>Category</strong></TableCell>
//                 <TableCell><strong>Stock</strong></TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => (
//                 <TableRow key={index}>
//                   <TableCell><Avatar src={item.image} alt={item.name} /></TableCell>
//                   <TableCell>{item.name}</TableCell>
//                   <TableCell>{item.category}</TableCell>
//                   <TableCell style={{ color: item.stock === 0 ? "red" : "green", fontWeight: "bold" }}>
//                     {item.stock}
//                   </TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>

//         {/* Pagination */}
//         <TablePagination
//           rowsPerPageOptions={[5, 10, 15]}
//           component="div"
//           count={filteredData.length}
//           rowsPerPage={rowsPerPage}
//           page={page}
//           onPageChange={handleChangePage}
//           onRowsPerPageChange={handleChangeRowsPerPage}
//         />
//       </CardContent>
//     </Card>
//   );
// };

// export default StockLevelsTable;

//LM
import React, { useEffect, useState } from "react";
import { Card, CardContent, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Collapse, IconButton } from "@mui/material";
import { getStockByCategory } from "../../../Services/DashboardService";// Import the service
import { ExpandMore, ExpandLess } from "@mui/icons-material";

const StockByCategory: React.FC<{ orgId: string }> = ({ orgId }) => {
  const [categoryStock, setCategoryStock] = useState<{ categoryName: string; totalStock: number; items: { name: string; stock: number }[] }[]>([]);
  const [expandedCategory, setExpandedCategory] = useState<string | null>(null);

  useEffect(() => {
    const fetchStockByCategory = async () => {
      try {
        const data = await getStockByCategory(orgId); // Call the service method
        setCategoryStock(data); // Set the categoryStock state with the response data
      } catch (error) {
        console.error("Error fetching stock by category:", error);
      }
    };

    fetchStockByCategory();
  }, [orgId]);

  return (
    <Card sx={{ borderRadius: 1, padding: 4 }}>
      <CardContent>
        <Typography variant="h6" sx={{ fontWeight: "bold", textAlign: "left", marginBottom: 2 }}>
          Stock by Category (with Items)
        </Typography>

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><strong>Category</strong></TableCell>
                <TableCell><strong>Total Stock</strong></TableCell>
                <TableCell><strong>Expand</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {categoryStock.map((category, index) => (
                <React.Fragment key={index}>
                  {/* Category Row */}
                  <TableRow>
                    <TableCell>{category.categoryName}</TableCell>
                    <TableCell style={{ fontWeight: "bold", color: category.totalStock === 0 ? "red" : "green" }}>
                      {category.totalStock}
                    </TableCell>
                    <TableCell>
                      <IconButton onClick={() => setExpandedCategory(expandedCategory === category.categoryName ? null : category.categoryName)}>
                        {expandedCategory === category.categoryName ? <ExpandLess /> : <ExpandMore />}
                      </IconButton>
                    </TableCell>
                  </TableRow>

                  {/* Expandable Row for Items */}
                  <TableRow>
                    <TableCell colSpan={3} style={{ padding: 0 }}>
                      <Collapse in={expandedCategory === category.categoryName} timeout="auto" unmountOnExit>
                        <Table size="small" sx={{ marginLeft: 2 }}>
                          <TableHead>
                            <TableRow>
                              <TableCell><strong>Item Name</strong></TableCell>
                              <TableCell><strong>Stock</strong></TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {category.items.map((item, itemIndex) => (
                              <TableRow key={itemIndex}>
                                <TableCell>{item.name}</TableCell>
                                <TableCell style={{ fontWeight: "bold", color: item.stock === 0 ? "red" : "green" }}>
                                  {item.stock}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default StockByCategory;

